import { render, staticRenderFns } from "./TemplateOrderMultiDetail.vue?vue&type=template&id=dcb4db62&scoped=true"
import script from "./TemplateOrderMultiDetail.vue?vue&type=script&lang=js"
export * from "./TemplateOrderMultiDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb4db62",
  null
  
)

export default component.exports